//- ANGULAR
import { Component } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

//- BACKEND
//- OWN
import { PermanentTableComponent } from '@features/receipts/components/permanent-table/permanent-table.component';
import {
  IFilters,
  PermanentTablePaginatedComponent,
} from '@features/receipts/components/permanent-table-paginated/permanent-table-paginated.component';
import { PrettyConsole } from '@app/shared/utils';
import { FileProcessorService } from '@app/shared/services/wasm/file-processor/file-processor.service';

import { ReceiptComponent } from '../../components/receipt/receipt.component';
import { NotificationService } from '@app/shared/services/notification/notification.service';
import { NotificationhubService } from '@app/shared/services/notificationhub/notificationhub.service';
import {
  FileParameter,
  GetTransferFilterStructureQuery,
  GetTransferReceiptsOfTodayQuery,
  ITransferReceiptDto,
  TransferReceiptClient,
  TransferReceiptDto,
} from '@tech/api-clients/receipts';
import { DataSource } from '@angular/cdk/collections';
import { TranslateModule } from '@ngx-translate/core';

//~ BEGIN

interface ReceiptDisplay {
  ok: boolean;
  file: string;
  [key: string]: string | number | boolean | Date | undefined;
}

@Component({
  selector: 'app-receipt-transfer',
  standalone: true,
  imports: [ReceiptComponent, TranslateModule],
  templateUrl: './receipt-transfer.component.html',
  styleUrl: './receipt-transfer.component.scss',
})
export class ReceiptTransferComponent extends ReceiptComponent {
  // displaying
  stagedreceipts: ReceiptDisplay[] = [];
  availablefilters: IFilters[] = [];
  displayedColumns: string[] = [
    'file',
    'err_line',
    ...Object.keys({}).map((c) => c.toLowerCase()),
  ];
  hidden_columns: string[] = [];

  override sse_name: string = 'TransferReceipt';

  // staging

  stagedfiles: Set<File> = new Set();

  // HACK: WASM
  validation_s = {};

  constructor(
    dialog: MatDialog,
    fileProcessor: FileProcessorService,
    notify: NotificationService,
    hub: NotificationhubService,
    private client: TransferReceiptClient
  ) {
    super(dialog, fileProcessor, notify, hub);
    this.validation_s = {
      fecha: {
        type: 'regex',
        pattern: '\\d{2}/\\d{2}/\\d{4}|\\d{4}/\\d{2}/\\d{2}',
      }
      // hora: {
      //   type: 'regex',
      //   pattern: '^([01]\\d|2[0-3]):[0-5]\\d(?<secs>:[0-5]\\d)?$',
      // },
    };

    this.available_filters = [
      {
        label: 'Initial Date',
        type: 'date',
        id: 'initial_date',
      },
      { label: 'End Date', type: 'date', id: 'end_date' },
    ];
    this.upload_handler = this.client_proc.bind(this);
    this.callme = this.lookup_permanent.bind(this);
    this.lookupPermanent = this.look_today.bind(this);
    this.get_paginated_data = this.get_paginated_data_c.bind(this);
    this.client
      .getFilterStructure(GetTransferFilterStructureQuery.fromJS({}))
      .subscribe({
        next: (x) => {
          var parsed = JSON.parse(x);
          this.availablefilters = parsed;
        },
        error: (e) => {
          PrettyConsole.ERROR(
            `Something failed while getting filter structure ${e}`
          );
        },
      });
  }
  client_proc = (files: FileParameter[]) => {
    return this.client.uploadTransferFiles(files);
  };

  look_today = () => {
    const loading$: BehaviorSubject<boolean> = new BehaviorSubject(true);
    const ds = new PermanentTransferReceipts();
    this.client
      .getTransferReceiptsOfToday(GetTransferReceiptsOfTodayQuery.fromJS({}))
      .subscribe({
        next: (receipts) => {
          ds.setData(receipts);
          loading$.next(false);
        },
        error: (err) => {
          PrettyConsole.ERROR(
            `getTransferReceiptsOfToday got error on subscribe ${err}`
          );
          loading$.next(false);
        },
      });
    this.dialog.open(PermanentTableComponent<PermanentTransferReceipts>, {
      width: '85vw',
      height: '80vh',
      data: {
        title: 'Receipts of last remittance',
        receipts: ds,
        display: Object.keys(TransferReceiptDto.prototype.toJSON()),
        loading$,
        callback: this.lookup_permanent,
      },
    });
  };

  lookup_permanent = () => {
    this.dialog.closeAll();
    if (this.available_filters.length === 0) {
      this.client
        .getFilterStructure(GetTransferFilterStructureQuery.fromJS({}))
        .subscribe({
          next: (x) => {
            var parsed = JSON.parse(x);
            this.availablefilters = parsed;
          },
          error: (e) => {
            PrettyConsole.ERROR(
              `Something failed while getting filter structure ${e}`
            );
          },
        });
    }
    const data_source = new PermanentTransferReceipts();
    this.dialog.open(PermanentTablePaginatedComponent<ITransferReceiptDto>, {
      width: '100vw',
      maxWidth: '98vw',
      height: '95vh',
      data: {
        receipts: data_source,
        display: Object.keys(TransferReceiptDto.prototype.toJSON()).filter(
          (d) => d !== 'id'
        ),
        callback: this.get_paginated_data,
        filters: this.availablefilters,
      },
    });
  };

  get_paginated_data_c = (page: number, size: number, filters: IFilters[]) => {
    let data = new BehaviorSubject<TransferReceiptDto[]>([]);
    let count = new BehaviorSubject<number>(0);

    let filter_values: Record<string, any> = {};
    filters.forEach((f) => {
      filter_values[f.id] = f.value === null ? undefined : f.value;
    });

    this.client
      .getAllTransferReceipts(page, size, JSON.stringify(filter_values))
      .subscribe({
        error: (_) => {
          PrettyConsole.ERROR(
            `Error while getting the transfer receipts. page: ${page}, size: ${size}`
          );
        },
        next: (d) => {
          if (d.count) count.next(d.count);
          if (d.receipts) data.next(d.receipts);
        },
      });
    return { count: count.asObservable(), data: data.asObservable() };
  };
}

export class PermanentTransferReceipts extends DataSource<ITransferReceiptDto> {
  private data = new BehaviorSubject<ITransferReceiptDto[]>([]);

  connect(): Observable<ITransferReceiptDto[]> {
    return this.data.asObservable();
  }

  addRow(row: ITransferReceiptDto) {
    const current = this.data.getValue();
    this.data.next([...current, row]);
  }

  setData(rows: TransferReceiptDto[]) {
    const data = rows.map((r) => r.toJSON());
    this.data.next(data);
  }

  disconnect(): void {}
}
